import React, { Component } from 'react';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import ReportList from '~/containers/reportList/reportList';

export default class CompletedBrewTransferReports extends Component {
  render() {
    return (
      <Page>
        <TitleBar back="/reports" backText="Reports" title="Completed brew transfer notification reports" />
        <ReportList reportType="COMPLETED_TRANSFER_BREW" reportFileName="completed_transfer_brew" />
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/completedBrewTransferReports/completedBrewTransferReports.jsx